module.exports = __webpack_public_path__ + "img/advantage_icon_available.2aea20e9.svg";